{
  "name": "@plugin-web-update-notification/umijs",
  "version": "2.0.2",
  "description": "Umi plugin for detect web page updates and notify.",
  "author": "Utopia",
  "license": "MIT",
  "homepage": "https://github.com/GreatAuk/plugin-web-update-notification",
  "repository": {
    "type": "git",
    "url": "https://github.com/GreatAuk/plugin-web-update-notification",
    "directory": "packages/umi-plugin"
  },
  "bugs": {
    "url": "https://github.com/GreatAuk/plugin-web-update-notification/issues"
  },
  "keywords": [
    "umi",
    "umi-plugin",
    "@plugin-web-update-notification/core",
    "web-update-notification"
  ],
  "sideEffects": false,
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "require": "./dist/index.js",
      "import": "./dist/index.mjs"
    }
  },
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "start": "tsx src/index.ts",
    "build": "tsup",
    "dev": "tsup --watch"
  },
  "peerDependencies": {
    "umi": "*"
  },
  "dependencies": {
    "@plugin-web-update-notification/core": "workspace:*"
  },
  "devDependencies": {
    "umi": "^4.0.2"
  }
}
